import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { COLLEGE } from '../constants';

const Navbar = () => {
  const [isNavCollapsed, setIsNavCollapsed] = useState(true);
  const { user, logout } = useAuth();
  const location = useLocation();

  const handleNavCollapse = () => setIsNavCollapsed(!isNavCollapsed);

  const handleLogout = async () => {
    await logout();
  };

  const isActive = (path) => {
    return location.pathname === path ? 'nav-link active' : 'nav-link';
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-dark bg-primary">
      <div className="container">
        <Link className="navbar-brand fw-bold d-flex align-items-center" to="/">
          <img 
            src={COLLEGE.LOGO_PATH} 
            alt="College Logo" 
            width="40" 
            height="40" 
            className="me-2"
            style={{ borderRadius: '50%', objectFit: 'cover' }}
          />
          {COLLEGE.FULL_NAME}
        </Link>
        
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded={!isNavCollapsed ? true : false}
          aria-label="Toggle navigation"
          onClick={handleNavCollapse}
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        
        <div className={`${isNavCollapsed ? 'collapse' : ''} navbar-collapse`} id="navbarNav">
          <ul className="navbar-nav me-auto">
            <li className="nav-item">
              <Link className={isActive('/')} to="/">Home</Link>
            </li>
            <li className="nav-item dropdown">
              <button className="nav-link dropdown-toggle" type="button" data-bs-toggle="dropdown">
                About
              </button>
              <ul className="dropdown-menu">
                <li><Link className="dropdown-item" to="/about">About Us</Link></li>
                <li><Link className="dropdown-item" to="/principal-message">Principal Message</Link></li>
                <li><Link className="dropdown-item" to="/administration">Administration</Link></li>
                <li><Link className="dropdown-item" to="/iqac">IQAC</Link></li>
                <li><Link className="dropdown-item" to="/aishe">AISHE</Link></li>
              </ul>
            </li>
            <li className="nav-item dropdown">
              <button className="nav-link dropdown-toggle" type="button" data-bs-toggle="dropdown">
                Academics
              </button>
              <ul className="dropdown-menu">
                <li><Link className="dropdown-item" to="/academics">Academics</Link></li>
                <li><Link className="dropdown-item" to="/courses">Courses</Link></li>
                <li><Link className="dropdown-item" to="/uprtou-study-centre">UPRTOU Study Centre</Link></li>
                <li><Link className="dropdown-item" to="/seminar-webinar">Seminar/Webinar</Link></li>
              </ul>
            </li>
            <li className="nav-item">
              <Link className={isActive('/faculty')} to="/faculty">Faculty</Link>
            </li>
            <li className="nav-item">
              <Link className={isActive('/gallery')} to="/gallery">Gallery</Link>
            </li>
            <li className="nav-item">
              <Link className={isActive('/students-corner')} to="/students-corner">Students Corner</Link>
            </li>
            <li className="nav-item">
              <Link className={isActive('/register')} to="/register">Student Registration</Link>
            </li>
          </ul>
          
          <ul className="navbar-nav">
            {user ? (
              <>
                <li className="nav-item">
                  <Link className="nav-link" to="/admin">Admin Dashboard</Link>
                </li>
                <li className="nav-item">
                  <button className="dropdown-item" onClick={handleLogout}>Logout</button>
                </li>
              </>
            ) : (
              <li className="nav-item">
                <Link className="nav-link" to="/admin/login">Admin Login</Link>
              </li>
            )}
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
